namespace GeniuzPOS.AdvPromo {
    export namespace LookupPromoIdService {
        export const baseUrl = 'AdvPromo/LookupPromoId';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LookupPromoIdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupPromoIdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "AdvPromo/LookupPromoId/Retrieve",
            List = "AdvPromo/LookupPromoId/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LookupPromoIdService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
